// NOTE: This file is not covered by automated tests - individual routes are tested as required
// We would essentially just be testing a Suspense block and a router, which is not worth the effort

import '../analytics'

import { LoadingPage } from 'mds-web-ui'
import React, { lazy, Suspense, useEffect } from 'react'
import { BrowserRouter, Route, Routes, useLocation } from 'react-router-dom'

import { Link } from '@/utils/Link'

import { pageView } from '../analytics'

const Login = lazy(() => import(/* webpackChunkName: "login" */ './Login'))
const Logout = lazy(() => import(/* webpackChunkName: "logout" */ './Logout'))
const Canvas = lazy(() => import(/* webpackChunkName: "canvas" */ '../components/canvases/Canvas'))
const Collections = lazy(() => import(/* webpackChunkName: "collections" */ './Collections'))

const Analytics = () => {
  const location = useLocation()

  useEffect(() => {
    pageView(location.pathname)
  }, [location])

  return null
}

const Home = () => {
  return (
    <BrowserRouter>
      <Analytics />
      <Suspense fallback={<LoadingPage LinkComponent={Link} />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route path="/sample/:canvasId" element={<Canvas />} />
          <Route path="*" element={<Collections />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default Home
